<template>
  <!--最外层包裹-->
  <div class="detais-wrap">
    <!--右侧包裹-->
    <div id='detais-warp' class="wrapper">
      <div class="topimg">
        <div ref="titleimg"></div>
      </div>
      <!--滚动列-->
      <div class="details">
        <h2 v-html="basicTitle">{{basicTitle}}</h2>
        <hr style="width: 100%">
        <div v-show='!videoobj.video' class="details-content Richtext" ref="Richtext" @contextmenu.prevent="show($event)" v-html="basicContent">
          {{basicContent}}
        </div>
        <div v-show='videoobj.video' class="videowrap">
          <div  class="video" id="video" style="width: 90%;height: 700px;background-color: #40a9ff"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {getUserToken} from '@/config/config.js'
  import {getdetais} from '@/api/detais.js'

  export default {
    data() {
      return {
        basicTitle: "",
        basicContent: "",
        basictopimg: "",
        videoobj:{
          container: '#video', //容器的ID或className
          variable: 'player',//播放函数名称
          autoplay:true,
          live:true,
          video: '',//视频地址-rtmp的地址就可以
        }
      }
    },
    mounted() {
      getUserToken();
      this.initdetais()
    },
    methods: {
      show(e) {
        return
      },
      initdetais() {
        let id = this.$route.params.id.split('&&')[0];
        if(id === "dqpzb"){
          this.videoobj.video = "rtmp://v.jinghailian.com/2020930/2020930?auth_key=1631020448-0-0-4a4060249a45c768b91ba1ed67403f77"
          this.basicTitle = "第七批在韩志愿军烈士遗骸归国纪实直播"
          document.title = "第七批在韩志愿军烈士遗骸归国纪实直播"
          var player =  new ckplayer(this.videoobj)
        }else {
          getdetais(id).then((res) => {
            if (res.code == 200 && res.data) {
              if(res.data.basicVideo){
                this.videoobj.video = res.data.basicVideo
                this.basicTitle = res.data.basicTitle
                this.basicContent = res.data.basicContent
                document.title = this.basicTitle
                var player =  new ckplayer(this.videoobj)
              }else if(!res.data.basicVideo){
                this.videoobj.video = "";
                this.basicTitle = res.data.basicTitle
                this.basicContent = res.data.basicContent
                document.title = this.basicTitle
              }
            }
          }).catch(() => {

          })
        }


      }

    }
  }
</script>
<style scoped>
  .sjjkz, .mjls, .zyzs {
    position: absolute;
    left: 50%;
    top: 0px;
    transform: translateX(-50%);
    background-size: 100% 100% !important;
    background-repeat: no-repeat !important;
    z-index: 10000;
  }

  .sjjkz {
    background: url("../../assets/img/sjjkz.png");
  }

  .mjls {
    background: url("../../assets/img/App.vue.png");
  }

  .zyzs {
    background: url("../../assets/img/zyzszx.png");
  }

  .detais-wrap {
    width: 100%;
    height: 100%;
    text-align: center;
    overflow-y: scroll;
  }

  #detais-warp {
    display: inline-block;
    box-sizing: border-box;
    width: 1800px;
    height: 100%;
    padding: 20px;
  }

  .topimg {
    position: relative;
    width: 100%;
    height: 250px;
    display: inline-block;
    background: url("../../assets/img/xq-top-bj.png") center center / cover no-repeat;
  }

  .details {
    text-align: left;
  }

  .details h2 {
    font-family: MicrosoftYaHei;
    font-size: 36px;
    color: #aa0000;
    margin-top: 18px;
    margin-bottom: 16px;
  }

  .details .details-content {
    margin: 0 auto;
    box-sizing: border-box;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 1px;
    color: #000000;
    overflow: hidden;
    padding: 30px 0px;
    padding-bottom: 100px;

  }

  .topimg > div {
    width: 700px;
    height: 115px;
    margin-top: 70px;
  }
  .videowrap{
    width: 100%;
    height: 800px;
  }
  #video{
    margin-left: 50%;
    transform: translateX(-50%);
  }

</style>



// WEBPACK FOOTER //
// src/pages/Details/index.vue